export default __webpack_public_path__ + "static/TitilliumWeb-Regular-522ebad20fa0808ac28478e2f0e48cb8.ttf";